import NotAuthorizedPage from './not-authorized-page';

export default NotAuthorizedPage;